import axios, { AxiosInstance } from 'axios';

class DecodeQPHook {
    private axiosInstance: AxiosInstance;

    constructor() {
        const baseUrl = import.meta.env.VITE_APP_DECODER_API_URL;

        this.axiosInstance = axios.create({
            baseURL: baseUrl
        });
    }

    post(encodedString: string): Promise<any> {
        return this.axiosInstance
            .post('/decode', encodedString, {
                headers: {
                    'Content-Type': 'text/plain'
                }
            })
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    }
}

const decodeqpHook = new DecodeQPHook();
export default decodeqpHook;
